/* eslint-disable */
export default [
	{
	  "name": "DA5 - Santolan",
	  "address": "Unit 1E GF Felmarc Bldg, 3 Amang Rodriguez Ave., Santolan",
	  "city": "Pasig City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.60302",
	  "lng": "121.092171",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "6:00 p.m."
	},
	{
	  "name": "Mottivic Money Changer and Pawn Polino 4",
	  "address": "Block 10 Lot 1 Molino 4, Max's Village, near SM Molino",
	  "city": "Bacoor",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.37333",
	  "lng": "120.98981",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "6:00 p.m."
	},
	{
	  "name": "Farmacia Liza",
	  "address": "4 San Agustin St., Brgy Palatiw",
	  "city": "Pasig City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.56148",
	  "lng": "121.06869",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "10:00 p.m."
	},
	{
	  "name": "Lakan Kitchenette and Money Changer",
	  "address": "Antipolo Street F B Harrisson 2127 Barangay 4 Zone 11 near Owwa",
	  "city": "Pasay City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.55671",
	  "lng": "120.99084",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Abelens Money Changer - Alaminos",
	  "address": "Quezon Avenue Unit 1A San Jose 2 Bldg. Poblacion near Nepo Mart",
	  "city": "Alaminos City",
	  "state": "Pangasinan",
	  "country": "PH",
	  "lat": "16.15595",
	  "lng": "119.97892",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Achievers Money Changer",
	  "address": "Domestic Road G/F Salem International Complex 191 at the back of Jollibee",
	  "city": "Pasay City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.52204",
	  "lng": "121.00083",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "New Batong Malake Public Market MPC",
	  "address": "Cabreras Compound, Market Site, Batong Malake near Batong Malake Public Market",
	  "city": "Los Banos",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.17523",
	  "lng": "121.24152",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:30  p.m."
	},
	{
	  "name": "KP's Pawnshop - Angat",
	  "address": "M.A. Fernando St. Sta Cruz",
	  "city": "Angat",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.93599",
	  "lng": "121.00212",
	  "phone_number": "555-55555",
	  "open": "7:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "KP's Pawnshop - Sta.Maria",
	  "address": "Pulong Buhangin Km 38 Barangay Pulong Buhangin near Pulo Buhangin Church",
	  "city": "Sta. Maria",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.86735",
	  "lng": "120.9996",
	  "phone_number": "555-55555",
	  "open": "7:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "Macdeco-Mauban Credit & Dev't Coop",
	  "address": "Corner Jocson Street, San Buenavista St. Barangay Mabato near City Hall of Mauban",
	  "city": "Mauban",
	  "state": "Quezon",
	  "country": "PH",
	  "lat": "14.11409",
	  "lng": "121.55526",
	  "phone_number": "555-55555",
	  "open": "7:30 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "Twin K Pawnshop and Jewelry",
	  "address": "Cagayan Valley Road National Highway Barangay Poblacion, in front of Mercury Drug Store",
	  "city": "San Ildefonso",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "15.10323",
	  "lng": "120.94108",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Champion Pawnshop Co - Alabang",
	  "address": "Montillano Street 252 Fortunato Bldg Alabang near Llanas Supermarket",
	  "city": "Muntinlupa City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.41914",
	  "lng": "121.04807",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Champion Pawnshop Co - Lopez",
	  "address": "N Lopez Avenue Sucat Unit 1 Annex TRDC Bldg. San Isidro near Banko Filipino Sucat Branch",
	  "city": "Paranaque City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.46796",
	  "lng": "121.01119",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Apung Monica",
	  "address": "Poblacion San Nicolas near Public Market",
	  "city": "Minalin",
	  "state": "Pampanga",
	  "country": "PH",
	  "lat": "14.96868",
	  "lng": "120.71077",
	  "phone_number": "555-55555",
	  "open": "8:30 a.m.",
	  "close": "4:00  p.m."
	},
	{
	  "name": "DLCLS Money Changer and Money Remittance Service",
	  "address": "M Basa Street, Brgy. VII C beside Superior Lending",
	  "city": "San Pablo",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.06873",
	  "lng": "121.31862",
	  "phone_number": "555-55555",
	  "open": "8:30 a.m.",
	  "close": "5:30  p.m."
	},
	{ 
	  "name": "Supreme Pawnshop and Jewelry",
	  "address": "JM Basa Masa St.Brgy Maria Clarainside Regent Arcade",
	  "city": "Iloilo City",
	  "state": "Iloilo",
	  "country": "PH",
	  "lat": "10.69332",
	  "lng": "122.57205",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:30  p.m."
	},
	{
	  "name": "A/J Raymundo Pawnshop Inc.",
	  "address": "Unit A Virka Building Edsa Roosevelt Avenue 1191 near Munoz Market, Katipunan",
	  "city": "Quezon City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.6561",
	  "lng": "121.0191",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "A Raymundo Pawnshop Inc.",
	  "address": "127 Manuel L. Quezon St. Brgy. San Roque",
	  "city": "Antipolo City",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.58163",
	  "lng": "121.17575",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Samutsari Store and Services",
	  "address": "Area H Phase 2 Block 17 Lot 1 Barangay San Rafael IV near Kristong Hari Catholic Church",
	  "city": "San Jose Del Monte",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.86444",
	  "lng": "121.043837",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "8:30  p.m."
	},
	{
	  "name": "Nuestra Senora Del Pilar Pawnshop",
	  "address": "Del Pilar Street 9 Barangay IV Beside Laurens Buko Pie and infront of Bayad Center and LDB Bank",
	  "city": "Alaminos",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.28339",
	  "lng": "121.41531",
	  "phone_number": "555-55555",
	  "open": "7:00 a.m.",
	  "close": "5:30  p.m."
	},
	{
	  "name": "DA5 - RCBC",
	  "address": "4th Floor Yuchengco Tower Rcbc Plaza 6819 Ayala Ave., Cor.Sen, Gil Puyat",
	  "city": "Makati City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.556885",
	  "lng": "121.023532",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "DA5 - Super 8 Ortigas",
	  "address": "Bldg. 8005 GP 05-8 Ortigas Ave., Brgy. Sta. Lucia",
	  "city": "Pasig City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.61347",
	  "lng": "121.08718",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "8:00  p.m."
	},
	{
	  "name": "Ibabao Multi Purpose Coop",
	  "address": "National Highway Brgy Ibabao Poblacion II near Kalayaan Christian School",
	  "city": "Cuenca",
	  "state": "Batangas",
	  "country": "PH",
	  "lat": "13.87218",
	  "lng": "120.97512",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "RVL Pawnshop",
	  "address": "Unit 4 Cecille Andres Space Rentals, Jp Rizal St., Poblacion",
	  "city": "Pandi",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.86619",
	  "lng": "120.95821",
	  "phone_number": "555-55555",
	  "open": "0:01 a.m.",
	  "close": "24:00  p.m."
	},
	{
	  "name": "Jhun & Kaye Bills Payment and Remittance Center",
	  "address": "Block 38 Lot 14 Phase 2 Greengate Homes, Malagasang IIB",
	  "city": "Imus City",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.418957",
	  "lng": "120.931232",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "San Lazaro Business",
	  "address": "Corner Carigma & Sen Lorenzo Sululong MEM CIR Brgy. San Jose",
	  "city": "Antipolo City",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.58847",
	  "lng": "121.17738",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Pics Pro Photo Center",
	  "address": "510 Earnshaw St., Brgy 407 Zone 42",
	  "city": "Sampaloc",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.60361",
	  "lng": "120.99323",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Axcezz Online Net",
	  "address": "Gueco cor Cavite st. Mt view Subdivision Balibago",
	  "city": "Angeles City",
	  "state": "Pampanga",
	  "country": "PH",
	  "lat": "15.16376",
	  "lng": "120.61042",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "COD Travel and Tours (Sanchez Money Remittances and Bayad Center)",
	  "address": "114 Malagasang IA",
	  "city": "Imus",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.37581",
	  "lng": "120.91473",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "9:00  p.m."
	},
	{
	  "name": "Bianca Gwen's Money Transfer",
	  "address": "800 Alexander St",
	  "city": "Urdaneta",
	  "state": "Pangasinan",
	  "country": "PH",
	  "lat": "15.975079",
	  "lng": "120.564501",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Prince and Precious E-business Center",
	  "address": "15018 E.Rodriguez ave., San Agustin vil., Brgy. Moonwalk",
	  "city": "Paranaque",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.490104",
	  "lng": "121.014131",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "8:30  p.m."
	},
	{
	  "name": "DEAC Filipinas Pawnshop Inc.",
	  "address": "1620 Linao St. (Former Dart St.)",
	  "city": "Paco",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.58214",
	  "lng": "120.991293",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "D' Little Giant Enterprise",
	  "address": "212 Augustinian cor. Jesuit St. Sta. Ana Village Sun Valley",
	  "city": "Paranaque",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.49393",
	  "lng": "121.03613",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "8:00  p.m."
	},
	{
	  "name": "AGR Travel and Tours",
	  "address": "#735, 3/f MC Square, Mindanao Avenue, Cor. Tandang Sora",
	  "city": "Quezon city",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.680046",
	  "lng": "121.03212",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "6:30  p.m."
	},
	{
	  "name": "Funtreats Travel and Tours",
	  "address": "138 m.h. Del Pilar St. Pinagbuhatan",
	  "city": "Pasig City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.621853",
	  "lng": "121.094344",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "St.Anthony's Pawnshop",
	  "address": "012 Amaya I Amaya",
	  "city": "Tanza",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.39287",
	  "lng": "120.854919",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Amabels Money Transfer & Bills Payment",
	  "address": "Block 4 Lot 1 Green Estate Phase 2 Malagasang 1F",
	  "city": "Imus",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.385704",
	  "lng": "120.925095",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "ARC Payment Center",
	  "address": "152 Mahai Phase V Barangay Bagong Nayon",
	  "city": "Antipolo city",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.716667",
	  "lng": "121.2166675",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "8:00  p.m."
	},
	{
	  "name": "Cornerstone Enterprises",
	  "address": " 2nd Floor SAG Bldg. Pinagbakahan",
	  "city": "Malolos city",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.861593",
	  "lng": "120.80973",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "Alzahra Travel and Tours",
	  "address": "2216 1A G. Tuazon, Balic Balic",
	  "city": "Sampaloc",
	  "state": "Manila",
	  "country": "PH",
	  "lat": "14.602972",
	  "lng": "120.995203",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "NSJ Mirra Business Center Main",
	  "address": "Montalban Town Center E.Rodriguez Hiway, San Jose",
	  "city": "Rodriguez",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.729684",
	  "lng": "121.138398",
	  "phone_number": "555-55555",
	  "open": "8:30 a.m.",
	  "close": "9:00  p.m."
	},
	{
	  "name": "Monteal Money Changer Services",
	  "address": "3rd flr. Unit C309A Venice Grand Canal, Mckinley Hill, Brgy. Pinagsama",
	  "city": "Taguig City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.533877",
	  "lng": "121.051284",
	  "phone_number": "555-55555",
	  "open": "11:00 a.m.",
	  "close": "7:30  p.m."
	},
	{
	  "name": "Inzda Voyager Internet Café",
	  "address": "#678 Zone 6 Kabalikat 7 Magsaysay Road, San Antonio",
	  "city": "Laguna",
	  "state": "",
	  "country": "PH",
	  "lat": "14.362228",
	  "lng": "121.036516",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "MKC Payment Center",
	  "address": "Shop 6 2nd Floor. Clubhouse Bonifacio Heights Condominium",
	  "city": "Taguig City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.498287",
	  "lng": "121.050028",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "8:00  p.m."
	},
	{
	  "name": "EFJ Velarde Service Center",
	  "address": "#955 J.P. Rizal Blvd. Brgy. POOC",
	  "city": "Sta Rosa city",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.28155",
	  "lng": "121.11604",
	  "phone_number": "555-55555",
	  "open": "00:00 a.m.",
	  "close": "24:00  p.m."
	},
	{
	  "name": "RCME Payment Services",
	  "address": "831 Geronimo St.",
	  "city": "Sampaloc",
	  "state": "Manila",
	  "country": "PH",
	  "lat": "14.60627",
	  "lng": "120.99724",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "Surepoint Bills Payment Center",
	  "address": "50 coaster St. Dona Ana Wet & Dry Market Brgy 175 Camarin",
	  "city": "Caloocan City",
	  "state": "Manila",
	  "country": "PH",
	  "lat": "14.76053",
	  "lng": "121.03217",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "JMCC Payment Service",
	  "address": "#64 Tolentino Street Barangay Damayan",
	  "city": "Quezon City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.63797",
	  "lng": "121.01485",
	  "phone_number": "555-55555",
	  "open": "7:00 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "Worley Express Payment Center",
	  "address": "Brgy. Bolbok",
	  "city": "Batangas City",
	  "state": "Batangas",
	  "country": "PH",
	  "lat": " 13.77754",
	  "lng": "121.05363",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "MRLB - Thrive Payment Center",
	  "address": "516 A Piko St. Brgy Talipapa Quirino Highway Novaliches",
	  "city": "Quezon City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.68849",
	  "lng": "121.02602",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "DA5 CNC",
	  "address": "Unit G37/G38 Cash and Carry Mall Filmore st., Palanan",
	  "city": "Makati city",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.5611",
	  "lng": "121.00461",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "9:00  p.m."
	},
	{
	  "name": "PJL Travel and Tours",
	  "address": "Unit B 9535 NIA Road Carsadang Bago 2",
	  "city": "Imus",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.43213",
	  "lng": "120.92261",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "Yugini Payment Center",
	  "address": "3990 Chicago, Joyous Hights Sudb. San Jose",
	  "city": "Antipolo City",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.58847",
	  "lng": "121.17738",
	  "phone_number": "555-55555",
	  "open": "7:00 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "Kinplace Bills Payment and Money Transfer",
	  "address": "T. Franco St. San Roque",
	  "city": "Victoria",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.22811",
	  "lng": "121.32607",
	  "phone_number": "555-55555",
	  "open": "8:30 a.m.",
	  "close": "5:30  p.m."
	},
	{
	  "name": "King's Money Transfer & Bills Payment Center",
	  "address": "0623 Sulucan",
	  "city": "Angat",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.94161",
	  "lng": "121.01614",
	  "phone_number": "555-55555", 
	  "open": "7:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "B-Roi Sari-Sari Store",
	  "address": "Dian Street 1779 D Corner Casino Street",
	  "city": "Makati",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.56019",
	  "lng": "121.00302",
	  "phone_number": "555-55555", 
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Dacaydi Remittance and Ticketing",
	  "address": "91-A Zamora St West Rembo",
	  "city": "Makati City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.55923",
	  "lng": "121.06264",
	  "phone_number": "555-55555", 
	  "open": "8:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "J Punzalan Business Center",
	  "address": "B215 l1 Dollar St. Cor. Peseta St., North Fairview 5",
	  "city": "Quezon City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.70921",
	  "lng": "121.05681",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "LHF Business Center",
	  "address": "Mabuhay City Subd. Block 84 Lot 6 Phase 4",
	  "city": "Dasmarinas",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "10.692086",
	  "lng": "122.216878",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "Abyeza Travel and Tours",
	  "address": "#18 A St. James St. Joseph Subdivion Pulang Lupa Dos",
	  "city": "Las Pinas",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.46117",
	  "lng": "120.98807",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "8:00  p.m."
	},
	{
	  "name": "Pinoy Properties Investment Corporation",
	  "address": "G01 Monarch Parksuites, Aseana Business Park, Bradco Ave.",
	  "city": "Paranaque City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.500702",
	  "lng": "120.991549",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "9:00  p.m."
	},
	{
	  "name": "EJT Internet Shop",
	  "address": "7 Rizal Avenue Brgy. San Isidro",
	  "city": "Taytay",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.55444",
	  "lng": "121.15301",
	  "phone_number": "555-55555",
	  "open": "8:30 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "Milas Drug Store And General Merchandize",
	  "address": "Purok 4, San Jose",
	  "city": "Floridablanca",
	  "state": "Pampanga",
	  "country": "PH",
	  "lat": "14.99077",
	  "lng": "120.49787",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Money Laundry",
	  "address": "005 A. Bonifacio Ave. Brgy. San Andres",
	  "city": "Cainta Rizal",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.580661",
	  "lng": "121.115471",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "8:00  p.m."
	},
	{
	  "name": "Nap Nap Enterprises",
	  "address": "A Mabini Ave Brgy 1 (Victory Mall and Tanauan Market 2nd Floor Nap Nap)",
	  "city": "Tanauan city",
	  "state": "Batangas",
	  "country": "PH",
	  "lat": "14.08469",
	  "lng": "121.15077",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "9:00  p.m."
	},
	{
	  "name": "AKC Travel and Tours and Money Changer",
	  "address": "158 IBP Road Common 2",
	  "city": "Quezon city ",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.69587",
	  "lng": "121.09528",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "E.Aranez Property Leasing",
	  "address": "New Panaderos St. Ground Flr Unit 2 Aranez Bldg beside RCBC Savings Bank",
	  "city": "Manila",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.5859",
	  "lng": "121.01911",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "Tayabas MPC",
	  "address": "Rizal cor Salazar St. Brgy. Poblacion near Mang Inasal",
	  "city": "Candelaria",
	  "state": "Quezon",
	  "country": "PH",
	  "lat": "13.92946",
	  "lng": "121.42431",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "DA5 - Shaw/Lanas",
	  "address": "8 West Capitol Drive Brgy. Kapitolyo",
	  "city": "Pasig city",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.57345",
	  "lng": "121.06105",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Bejar Enterprises",
	  "address": "Sandico Street, Abangan Sur",
	  "city": "Marilao",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.76232",
	  "lng": "120.92183",
	  "phone_number": "555-55555",
	  "open": "6:00 a.m.",
	  "close": "8:00  p.m."
	},
	{
	  "name": "D'May 878 Inc.(Main)",
	  "address": "Stall C Pacita Shopping Arcade, Pacita Complex",
	  "city": "San Pedro",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.34321",
	  "lng": "121.05707",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "D'May 878 Inc.(Branch 1)",
	  "address": "Redor St in front of public market",
	  "city": "Siniloan",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.42475",
	  "lng": "121.44712",
	  "phone_number": "555-55555", 
	  "open": "8:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "D'May 878 Inc.(Branch 2)",
	  "address": "511 Rizal Blvd, Poblacion",
	  "city": "Sta. Rosa",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.31916",
	  "lng": "121.10178",
	  "phone_number": "555-55555",  
	  "open": "8:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "D'May 878 Inc.(Branch 3)",
	  "address": "202 Gen. Capinpin st. Poblacion",
	  "city": "Binan",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.33868",
	  "lng": "121.08337",
	  "phone_number": "555-55555",  
	  "open": "8:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "D'May 878 Inc.(Branch 4)",
	  "address": "# 75 San Vicente st., Nueva",
	  "city": "San Pedro",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.36378",
	  "lng": "121.05682",
	  "phone_number": "555-55555",  
	  "open": "8:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "May's Money Transfer & Bills Payment Center",
	  "address": "Crossing, Partida",
	  "city": "Norgazagaray",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.89937",
	  "lng": "121.03378",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Bromar Express Payment and Remittance Center (Branch)",
	  "address": "Block 16b, Lot 4, Phase 5, Southville 9, Pinugay",
	  "city": "Baras",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.114045",
	  "lng": "121.393359",
	  "phone_number": "555-55555",
	  "open": "00:00 a.m.",
	  "close": "24:00  p.m."
	},
	{
	  "name": "ARCM Payment Center",
	  "address": "#2 Tocs ave. Summerville Subdivision,Mayamot",
	  "city": "Antipolo City",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.62335",
	  "lng": "121.15713",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "Joyluck Forex, Inc.",
	  "address": "Paseo De Sta Rosa",
	  "city": "Sta.Rosa",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.246372",
	  "lng": "121.06373",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "Catholic Servants of Christ Community Multipurpose Cooperative (CASECHCOMMPC)",
	  "address": "casechcom mpc bldg., #377 Dama de Noche st. Sullivan",
	  "city": "Baliwag",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.85715",
	  "lng": "120.81086",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Catholic Servants of Christ Community Multipurpose Cooperative (SATELLITE OFFICE)",
	  "address": "STALL K, RON RON MARKET, TANGOS",
	  "city": "Baliwag",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.911517",
	  "lng": "120.766691",
	  "phone_number": "555-55555",
	  "open": "7:30 a.m.",
	  "close": "5:30  p.m."
	},
	{
	  "name": "St.Anthony's Pawnshop - Branch 3",
	  "address": "#2 Sampalucan Street",
	  "city": "Gen. trias",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.12901",
	  "lng": "120.9064",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "King's Money Transfer & Bills Payment Center - Branch 1",
	  "address": "Sili Bata",
	  "city": "Pandi",
	  "state": "Bulacan",
	  "country": "PH",
	  "lat": "14.84851",
	  "lng": "120.93911",
	  "phone_number": "555-55555",
	  "open": "7:00 a.m.",
	  "close": "6:00  p.m."
	},
	{
	  "name": "MAJEANCDL Payment Center",
	  "address": "Lacanienta Comp near Alfamart Cabrera rd., Sitio Burol",
	  "city": "Taytay",
	  "state": "Rizal",
	  "country": "PH",
	  "lat": "14.57009",
	  "lng": "121.15444",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "St.Anthony's Pawnshop (Head Office)",
	  "address": "852 P. Burgos Ave., San Roque",
	  "city": "Cavite city",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.47615",
	  "lng": "120.88971",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Agencia De Empenos De Myrna B Aguirre",
	  "address": "617 San Andres 1004",
	  "city": "Malate",
	  "state": "Manila",
	  "country": "PH",
	  "lat": "14.568921",
	  "lng": "120.986823",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Agencia De Empenos De Myrna B Aguirre - President",
	  "address": "President Avenue 15 Barangay BF Homes 1 Beside PSbank",
	  "city": "Paranaque",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.457891",
	  "lng": "121.032429",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Agencia De Empenos De Myrna B Aguirre - San Isidro",
	  "address": "Sucat Road Richland Commercial Bldg San Isidro  near Puregold",
	  "city": "Paranaque",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.48474",
	  "lng": "120.993619",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "PH Bascon Pawnshop Ho",
	  "address": "Unit B the Grand bldg. b5 l35 Naga road San Antonio Valley 7 Pulang Lupa Dos",
	  "city": "Las Pinas City",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.471829",
	  "lng": "120.977026",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "May's Bills Payment & Remittance Center",
	  "address": "P5, B24,L15 Parklane Subd San Francisco",
	  "city": "General Trias",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.32302",
	  "lng": "120.91123",
	  "phone_number": "555-55555",
	  "open": "9:00 a.m.",
	  "close": "7:00  p.m."
	},
	{
	  "name": "Green Express",
	  "address": "2nd Floor. Rm. 1 Fernandez Bldg. Andres Bonifacio",
	  "city": "Diffun",
	  "state": "Quirino",
	  "country": "PH",
	  "lat": "16.595671",
	  "lng": "121.503751",
	  "phone_number": "555-55555",
	  "open": "7:30 a.m.",
	  "close": "7:30  p.m."
	},
	{
	  "name": "Hanbin Payment Center",
	  "address": "Angelina Canaynay AV B9 l7 BF Martinville Manuyo Dos",
	  "city": "Las Pinas",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.464734",
	  "lng": "120.996738",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Agencia De Empenos De Myrna B Aguirre-Pacita 2",
	  "address": "61 Pacita Ave. Pacita Complex",
	  "city": "San Pedro",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.364217",
	  "lng": "121.044716",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Janowens Travel and Tours Services",
	  "address": "Stall #2 Libertad Near Public Market",
	  "city": "San Narciso",
	  "state": "Zambales",
	  "country": "PH",
	  "lat": "15.0143",
	  "lng": "120.0803",
	  "phone_number": "555-55555",
	  "open": "7:30 a.m.",
	  "close": "5:30  p.m."
	},
	{
	  "name": "Quickplay.com Computer Services",
	  "address": "Pob. Center Ramos Tarlac",
	  "city": "Pob. Center Ramos",
	  "state": "Tarlac",
	  "country": "PH",
	  "lat": "15.672568",
	  "lng": "120.636294",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Flourish Money Changer",
	  "address": "Seascape Village, Zoilo Hilario St.Corner at Ang Dela Rama CCP Complex.076",
	  "city": "Pasay",
	  "state": "Metro Manila",
	  "country": "PH",
	  "lat": "14.543759",
	  "lng": "120.995466",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Fix R Business Center",
	  "address": "B5 Lot 158 Summerfield Subdivision, Brgy. Osorio",
	  "city": "Trece Martires",
	  "state": "Cavite",
	  "country": "PH",
	  "lat": "14.28323",
	  "lng": "120.86766",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Jarel Gasoline Station",
	  "address": "National Highway, North Poblacion",
	  "city": "Gabaldon",
	  "state": "Nueva Ecija",
	  "country": "PH",
	  "lat": "15.45371",
	  "lng": "121.33812",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "8:00  p.m."
	},
	{
	  "name": "Tayabas MPC Brach 2 Pagsanjan Branch",
	  "address": "Gen Taino St. Brgy Poblacion Near Church",
	  "city": "Pagsanjan",
	  "state": "Laguna",
	  "country": "PH",
	  "lat": "14.27098",
	  "lng": "121.45615",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Mel's Business Center",
	  "address": "Driza Bldg. Rajah Soliman Street Brgy.4 Poblacion",
	  "city": "San Jose",
	  "state": "Occidental Mindoro",
	  "country": "PH",
	  "lat": "12.35323",
	  "lng": "121.06323",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	},
	{
	  "name": "Tayabas Community Multi-Purpose Cooperative-Gumaca",
	  "address": "Tanada St.Cor. M.L. Quezon St. Brgy San Diego",
	  "city": "Gumaca",
	  "state": "Quezon",
	  "country": "PH",
	  "lat": "13.92152",
	  "lng": "122.10055",
	  "phone_number": "555-55555",
	  "open": "8:00 a.m.",
	  "close": "5:00  p.m."
	}
	]
  